import React, { useState, useEffect } from "react";
import axios from "axios";

function MobilePhoneForm({ additionalAttributes, setAdditionalAttributes, subCategoryId }) {
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");

  // Debug logging
  useEffect(() => {
    console.log('📱 MobilePhoneForm mounted with subCategoryId:', subCategoryId);
    console.log('📋 Current additionalAttributes:', additionalAttributes);
  }, [subCategoryId, additionalAttributes]);

  useEffect(() => {
    if (subCategoryId) {
      console.log('📦 Fetching brands for mobile phones...');
      axios.get(`https://api.herracim.az/api/Brand/BySubCategoryId?subCategoryId=${subCategoryId}`)
        .then(response => {
          console.log('✅ Brands loaded:', response.data.length, 'items');
          setFilteredBrands(response.data);
          setFilteredModels([]);
        })
        .catch(error => {
          console.error('❌ Error loading brands:', error);
          setFilteredBrands([]);
        });
    } else {
      setFilteredBrands([]);
      setFilteredModels([]);
    }
  }, [subCategoryId]);

  useEffect(() => {
    if (selectedBrand) {
      console.log('📦 Fetching models for brand:', selectedBrand);
      axios.get(`https://api.herracim.az/api/Model/ByBrandId?brandId=${selectedBrand}`)
        .then(response => {
          console.log('✅ Models loaded:', response.data.length, 'items');
          setFilteredModels(response.data);
        })
        .catch(error => {
          console.error('❌ Error loading models:', error);
          setFilteredModels([]);
        });
    } else {
      setFilteredModels([]);
    }
  }, [selectedBrand]);

  const handleBrandChange = (e) => {
    const brandId = e.target.value;
    console.log('🏷️ Brand selected:', brandId);
    
    setSelectedBrand(brandId);
    setAdditionalAttributes({
      ...additionalAttributes,
      brandId: brandId,
      modelId: ""
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`🔧 Field changed: ${name} = ${value}`);
    
    setAdditionalAttributes({
      ...additionalAttributes,
      [name]: value,
    });
  };

  const handleBooleanChange = (e) => {
    const { name, value } = e.target;
    const boolValue = value === "true";
    
    console.log(`✅ Boolean field changed: ${name} = ${boolValue}`);
    
    setAdditionalAttributes({
      ...additionalAttributes,
      [name]: boolValue,
    });
  };

  return (
    <div className="mobilePhoneForm">
      {/* Marka */}
      <div>
        <h3>
          Marka <span>*</span>
          <span className="tooltip-icon" title="Telefon istehsalçısı">ℹ️</span>
        </h3>
        <select 
          name="brandId" 
          onChange={handleBrandChange} 
          disabled={filteredBrands.length === 0} 
          defaultValue=""
        >
          <option value="" disabled>
            {filteredBrands.length === 0 ? 'Yüklənir...' : 'Seçin'}
          </option>
          {filteredBrands.map((brand) => (
            <option key={brand.id} value={brand.id}>{brand.name}</option>
          ))}
        </select>
      </div>

      {/* Model */}
      <div>
        <h3>
          Model <span>*</span>
          <span className="tooltip-icon" title="Telefon modeli">ℹ️</span>
        </h3>
        <select 
          name="modelId" 
          onChange={handleChange} 
          disabled={filteredModels.length === 0} 
          defaultValue=""
        >
          <option value="" disabled>
            {selectedBrand ? (filteredModels.length === 0 ? 'Yüklənir...' : 'Seçin') : 'Əvvəlcə marka seçin'}
          </option>
          {filteredModels.map((model) => (
            <option key={model.id} value={model.id}>{model.name}</option>
          ))}
        </select>
      </div>

      {/* Texniki detalları */}
      <div>
        <h3>
          Yaddaş (GB) <span>*</span>
          <span className="tooltip-icon" title="Daxili yaddaş (internal storage)">ℹ️</span>
        </h3>
        <select name="storage" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="16">16 GB</option>
          <option value="32">32 GB</option>
          <option value="64">64 GB</option>
          <option value="128">128 GB</option>
          <option value="256">256 GB</option>
          <option value="512">512 GB</option>
          <option value="1024">1 TB</option>
        </select>
      </div>

      <div>
        <h3>
          RAM (GB) <span>*</span>
          <span className="tooltip-icon" title="Operativ yaddaş">ℹ️</span>
        </h3>
        <select name="ram" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="1">1 GB</option>
          <option value="2">2 GB</option>
          <option value="3">3 GB</option>
          <option value="4">4 GB</option>
          <option value="6">6 GB</option>
          <option value="8">8 GB</option>
          <option value="12">12 GB</option>
          <option value="16">16 GB</option>
        </select>
      </div>

      <div>
        <h3>
          Əməliyyat sistemi <span>*</span>
          <span className="tooltip-icon" title="Operating System">ℹ️</span>
        </h3>
        <select name="operatingSystem" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Android">Android</option>
          <option value="iOS">iOS (iPhone)</option>
          <option value="HarmonyOS">HarmonyOS (Huawei)</option>
        </select>
      </div>

      {/* Boolean seçimlər */}
      <div>
        <h3>
          5G dəstəyi <span>*</span>
          <span className="tooltip-icon" title="5G şəbəkə dəstəyi">ℹ️</span>
        </h3>
        <select name="is5GSupported" onChange={handleBooleanChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli, 5G ✅</option>
          <option value="false">Xeyr, 4G/LTE</option>
        </select>
      </div>

      <div>
        <h3>
          Dual SIM <span>*</span>
          <span className="tooltip-icon" title="İki SIM kart dəstəyi">ℹ️</span>
        </h3>
        <select name="isDualSIM" onChange={handleBooleanChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr (Tək SIM)</option>
        </select>
      </div>

      <div>
        <h3>
          Yaddaş kartı dəstəyi <span>*</span>
          <span className="tooltip-icon" title="MicroSD kart dəstəyi">ℹ️</span>
        </h3>
        <select name="hasExpandableStorage" onChange={handleBooleanChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          NFC <span>*</span>
          <span className="tooltip-icon" title="elaqeless ödəniş">ℹ️</span>
        </h3>
        <select name="hasNFC" onChange={handleBooleanChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Wireless Charging <span>*</span>
          <span className="tooltip-icon" title="Simsiz şarj dəstəyi">ℹ️</span>
        </h3>
        <select name="hasWirelessCharging" onChange={handleBooleanChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Zəmanət var? <span>*</span>
          <span className="tooltip-icon" title="Rəsmi zəmanət">ℹ️</span>
        </h3>
        <select name="hasWarranty" onChange={handleBooleanChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli, zəmanətli ✅</option>
          <option value="false">Xeyr, zəmanətsiz ❌</option>
        </select>
      </div>

      {/* Digər sahələr */}
      <div>
        <h3>
          Əsas kamera (MP) <span>*</span>
          <span className="tooltip-icon" title="Arxa kamera megapiksel">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="mainCameraMP" 
          placeholder="48"
          min="2"
          max="200"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Ön kamera (MP) <span>*</span>
          <span className="tooltip-icon" title="Selfie kamera">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="frontCameraMP" 
          placeholder="12"
          min="2"
          max="60"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Batareya (mAh) <span>*</span>
          <span className="tooltip-icon" title="Batareya tutumu">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="batteryCapacity" 
          placeholder="5000"
          min="1000"
          max="10000"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Rəng <span>*</span>
          <span className="tooltip-icon" title="Telefon rəngi">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="color" 
          placeholder="Qara, Ağ, Mavi..."
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Vəziyyəti <span>*</span>
          <span className="tooltip-icon" title="Telefonun fiziki vəziyyəti">ℹ️</span>
        </h3>
        <select name="condition" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Yeni">Yeni (Qutuda)</option>
          <option value="İşlənmiş">İşlənmiş (Yaxşı vəziyyət)</option>
          <option value="Orta">Orta vəziyyət</option>
          <option value="Zədəli">Zədəli / Təmirə ehtiyac</option>
        </select>
      </div>
    </div>
  );
}

export default MobilePhoneForm;